import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

const MAX_CART_QTY = 3;

/**
 * Cart quantity selector with a hard limit of 3 units per line.
 * - "+" is disabled only when value >= 3
 * - "−" is disabled only when value <= min
 *
 * @extends {QuantitySelectorComponent}
 */
export class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  connectedCallback() {
    super.connectedCallback();
    const { quantityInput } = this.refs;
    if (quantityInput) quantityInput.max = String(MAX_CART_QTY);
  }

  getEffectiveMax() {
    return MAX_CART_QTY; // Límite fijo, sin depender del max del tema
  }

  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { min, value } = this.getCurrentValues();

    minusButton.disabled = value <= min;
    plusButton.disabled = value >= MAX_CART_QTY;
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}

// Límite máximo de 3 unidades por variante en el carrito
function initCartLimit() {
  function enforceCartLimit() {
    document.querySelectorAll('[name="updates[]"], [name^="updates["]').forEach(function (input) {
      const val = parseInt(input.value, 10);
      if (!isNaN(val) && val > MAX_CART_QTY) {
        input.value = MAX_CART_QTY;
      }
    });
  }

  document.addEventListener('change', function (e) {
    const input = e.target;
    if (input.matches('[name="updates[]"], [name^="updates["]')) {
      const val = parseInt(input.value, 10);
      if (!isNaN(val) && val > MAX_CART_QTY) {
        input.value = MAX_CART_QTY;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }, true);

  enforceCartLimit();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartLimit);
} else {
  initCartLimit();
}